import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { FaUserShield, FaEnvelope, FaLock } from 'react-icons/fa';
import './Reg.css';

const Register = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const navigate = useNavigate();

  const API_URL = 'https://backend.aktcorp.com/admin/register';

  const handleRegister = async (e) => {
    e.preventDefault();

    if (password.length < 6) {
      setError('Password must be at least 6 characters long.');
      return;
    }

    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    setLoading(true);
    setError('');
    setSuccessMessage('');

    try {
      const response = await axios.post(
        API_URL,
        {
          name,
          email,
          password,
          confrim_password: confirmPassword, // must match backend typo
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.status === 201) {
        setSuccessMessage(response.data.message || 'Registration successful!');

        // Optionally, you can save the token (response.data.token) to localStorage here if you want

        setTimeout(() => {
          setLoading(false);
          setSuccessMessage('');
          setName('');
          setEmail('');
          setPassword('');
          setConfirmPassword('');
          navigate('/login'); // Redirect to login page after success
        }, 3000);
      }
    } catch (error) {
      setLoading(false);
      setError(
        error.response?.data?.message ||
          'Registration failed. Please try again.'
      );
      setTimeout(() => setError(''), 3000);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0c2341] p-2 md:!p-0">
      <div className="bg-[#374151] p-8 rounded-lg shadow-lg max-w-md w-full">
        <div className="flex items-center justify-center gap-1 mb-6">
          <FaUserShield className="text-5xl text-indigo-400" />
          <h2 className="text-3xl font-bold text-gray-100 mt-1">Register</h2>
        </div>

        {error && <p className="text-red-500 text-center">{error}</p>}
        {successMessage && (
          <p className="text-green-400 text-center mb-4">{successMessage}</p>
        )}

        <form onSubmit={handleRegister}>
          {/* Name Input */}
          <div className="mb-4">
            <label className="block text-indigo-50 text-sm font-bold mb-2">
              Name:
            </label>
            <div className="flex items-center border border-gray-600 rounded-md bg-gray-800 focus-within:ring-2 focus-within:ring-indigo-600 transition duration-300">
              <FaUserShield className="text-indigo-400 ml-2" />
              <input
                type="text"
                className="w-full p-2 pl-10 rounded-md bg-[#1f2937] text-gray-200 focus:outline-none"
                placeholder="Enter your name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>
          </div>

          {/* Email Input */}
          <div className="mb-4">
            <label className="block text-indigo-50 text-sm font-bold mb-2">
              Email:
            </label>
            <div className="flex items-center border border-gray-600 rounded-md bg-gray-800 focus-within:ring-2 focus-within:ring-indigo-600 transition duration-300">
              <FaEnvelope className="text-indigo-400 ml-2" />
              <input
                type="email"
                className="w-full p-2 rounded-md bg-[#1f2937] text-gray-200 focus:outline-none"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
          </div>

          {/* Password Input */}
          <div className="mb-4">
            <label className="block text-indigo-50 text-sm font-bold mb-2">
              Password:
            </label>
            <div className="flex items-center border border-gray-600 rounded-md bg-gray-800 focus-within:ring-2 focus-within:ring-indigo-600 transition duration-300">
              <FaLock className="text-indigo-400 ml-2" />
              <input
                type="password"
                className="w-full p-2 rounded-md bg-[#1f2937] text-gray-200 focus:outline-none"
                placeholder="Create a password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            {password.length > 0 && password.length < 6 && (
              <p className="text-red-400 text-sm mt-1">
                * Password must be at least 6 characters long.
              </p>
            )}
          </div>

          {/* Confirm Password Input */}
          <div className="mb-6">
            <label className="block text-indigo-50 text-sm font-bold mb-2">
              Confirm Password:
            </label>
            <div className="flex items-center border border-gray-600 rounded-md bg-gray-800 focus-within:ring-2 focus-within:ring-indigo-600 transition duration-300">
              <FaLock className="text-indigo-400 ml-2" />
              <input
                type="password"
                className="w-full p-2 rounded-md bg-[#1f2937] text-gray-200 focus:outline-none"
                placeholder="Confirm your password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
            </div>
            {confirmPassword && password !== confirmPassword && (
              <p className="text-red-400 text-sm mt-1">* Passwords do not match.</p>
            )}
          </div>

          {/* Submit Button */}
          <div className="flex justify-center">
            <button
              type="submit"
              className="w-full bg-indigo-600 text-white font-bold py-2 px-4 rounded-md hover:bg-indigo-700 disabled:opacity-50"
              disabled={
                loading || password.length < 6 || password !== confirmPassword
              }
            >
              {loading ? 'Registering...' : 'Register'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Register;
